export const padCarouselItems = (list) => {
  switch (list.length) {
    case 2:
      return list.concat(list, list);
    case 3:
    case 4:
      return list.concat(list);
    default:
      return list;
  }
};



// WEBPACK FOOTER //
// ./src/helpers/carousel.js